"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _useInsertStyles = _interopRequireDefault(require("./utils/useInsertStyles"));
var _svgBaseProps = _interopRequireDefault(require("./utils/svgBaseProps"));
var _devConsoleLog = require("../_util/devConsoleLog");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Icon = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    // affect outter <i>...</i>
    className,
    // affect inner <svg>...</svg>
    component: Component,
    viewBox,
    spin,
    rotate,
    tabIndex,
    onClick,
    // children
    children,
    style,
    ...restProps
  } = props;
  (0, _devConsoleLog.error)(!Boolean(Component || children), 'Icon', 'Should have `component` prop or `children`.');
  (0, _useInsertStyles.default)();
  const classString = (0, _classnames.default)('anticon', {
    'anticon-spin': !!spin
  }, className);

  // const svgClassString = classNames({
  //   'anticon-spin': !!spin,
  // });

  // const svgStyle = rotate
  //   ? {
  //       msTransform: `rotate(${rotate}deg)`,
  //       transform: `rotate(${rotate}deg)`,
  //     }
  //   : undefined;

  const innerSvgProps = {
    ..._svgBaseProps.default,
    //className: svgClassString,
    //style: svgStyle,
    viewBox
  };
  if (!viewBox) {
    delete innerSvgProps.viewBox;
  }

  // component > children
  const renderInnerNode = () => {
    if (Component) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
        ...innerSvgProps,
        children: children
      });
    }
    if (children) {
      (0, _devConsoleLog.error)(!(Boolean(viewBox) || React.Children.count(children) === 1 && /*#__PURE__*/React.isValidElement(children) && React.Children.only(children).type === 'use'), 'Icon', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
        ...innerSvgProps,
        viewBox: viewBox,
        children: children
      });
    }
    return null;
  };
  let iconTabIndex = tabIndex;
  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    role: "img",
    ...restProps,
    ref: ref,
    tabIndex: iconTabIndex,
    onClick: onClick,
    className: classString,
    style: {
      ...style,
      ...(rotate ? {
        msTransform: "rotate(".concat(rotate, "deg)"),
        transform: "rotate(".concat(rotate, "deg)")
      } : {})
    },
    children: renderInnerNode()
  });
});
Icon.displayName = 'AntdIcon';
var _default = exports.default = Icon;